var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsXd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 44.85,
    viewBox: "0 0 46 44.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_xd",
    transform: "translate(-546 -914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M8.146,0H37.854A8.139,8.139,0,0,1,46,8.146V36.7a8.139,8.139,0,0,1-8.146,8.146H8.146A8.139,8.139,0,0,1,0,36.7V8.146A8.139,8.139,0,0,1,8.146,0Z",
    transform: "translate(546 914)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M52.448,60.287,46.7,69.775l6.133,10.063a.33.33,0,0,1,.038.23c-.019.077-.1.019-.211.038H48.27c-.307,0-.517-.019-.652-.211-.4-.805-.824-1.591-1.227-2.4-.4-.786-.843-1.591-1.3-2.415s-.92-1.648-1.38-2.492H43.67c-.4.824-.843,1.648-1.284,2.472s-.882,1.648-1.3,2.453c-.441.805-.882,1.629-1.322,2.415-.077.192-.23.211-.441.211H35.1c-.077,0-.134.038-.134-.058a.266.266,0,0,1,.038-.211L40.967,70.1,35.16,60.268c-.058-.077-.077-.153-.038-.192A.222.222,0,0,1,35.313,60h4.351a1.131,1.131,0,0,1,.268.038.544.544,0,0,1,.192.173c.364.824.786,1.648,1.227,2.472.46.824.9,1.629,1.38,2.434.46.805.882,1.61,1.284,2.434h.038c.4-.843.824-1.668,1.246-2.473s.862-1.61,1.3-2.415.863-1.629,1.284-2.415A.326.326,0,0,1,48,60.057a.365.365,0,0,1,.249-.038h4.044a.177.177,0,0,1,.211.134c.019.019-.019.1-.057.134Z",
    transform: "translate(517.74 865.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M138.366,73.463a9.529,9.529,0,0,1-4.121-.863,6.682,6.682,0,0,1-2.894-2.607,8.293,8.293,0,0,1-1.054-4.37,7.872,7.872,0,0,1,1.054-4.044,7.959,7.959,0,0,1,3.048-2.971,9.8,9.8,0,0,1,4.849-1.112,3.423,3.423,0,0,1,.4.019c.172.019.364.019.594.038V51.5c0-.134.057-.211.192-.211h3.891a.172.172,0,0,1,.192.134V69.707c0,.345.019.728.038,1.15.038.4.057.786.077,1.112a.311.311,0,0,1-.192.307,14.638,14.638,0,0,1-3.124.92A16.906,16.906,0,0,1,138.366,73.463Zm1.878-3.833V61.2a4.9,4.9,0,0,0-.518-.1c-.211-.019-.422-.038-.633-.038a4.725,4.725,0,0,0-2.166.5,4.3,4.3,0,0,0-1.629,1.418,4.249,4.249,0,0,0-.632,2.434,5.341,5.341,0,0,0,.326,1.974,3.746,3.746,0,0,0,.863,1.361,3.311,3.311,0,0,0,1.3.767,5.017,5.017,0,0,0,1.591.249c.288,0,.556-.019.805-.038A1.676,1.676,0,0,0,140.244,69.63Z",
    transform: "translate(440.677 872.545)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsXd);
export default __webpack_public_path__ + "static/media/skills_xd.5b6d8416a37509917b191702870ef97d.svg";
export { ForwardRef as ReactComponent };